/*
  Dtcs state
*/
export default {
  loading: false,
  eventList: [],
  eventDictList: []
}
